import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { deletePost } from 'reducers/feed/feed.actions';
import { fetchProfileSubs } from '../../reducers/profile/profile.actions';
import Home from '../home/Home';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import { EmptyBookmark } from '../../components/Icons';
import Loader from 'components/Loader';

const Bookmarks = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userPhotoVideoObj, setUserPhotoVideoObj] = useState({});
  const { userId } = useParams();
  const currentUser = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [bookmark, setBookmark] = useState([]);

  const user = useSelector(selectAuthUser);

  const callback = useCallback(bar => {
    setBookmark(bar);
  }, []);
  useEffect(() => {}, []);

  const handlePostDelete = async (id) => {
    if (window.confirm(t('This action can not be undone. Are you sure you want to delete this post?'))) {
      setIsLoading(true);
      await dispatch(deletePost(id)).finally(() => {
        setIsLoading(false);
      });
      await dispatch(fetchProfileSubs(userId || currentUser.id))
        .then(res => {
          setUserPhotoVideoObj(res);
        })
        .catch(err => {
          console.log('fetch user error', err);
        });
    }
  };

  return (
    <>
      <div className="bookmarks-wrapper menu-user-nickname">
        <p> {t('Bookmarks')}</p>
      </div>
      <hr className="bookmarks-hr" />
      <Loader isLoadin={isLoading}/>  
      <div className="bookmark-container posts-list-container ">
        <Home userId={user.id} currentUser={user} parentCallback={callback} handlePostDelete={handlePostDelete} style={{ maxWidth: '100%' }} />

        {bookmark.length < 1 && (
          <div className="empty-bookmarks">
            <EmptyBookmark />
            <p> {t('No bookmarks yet')}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Bookmarks;
